import CustomModalHeader from 'components/Custom/CustomModalHeader'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Modal,
  ModalBody,
  ModalFooter,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap'
import {
  resetSelectedItems,
  setAssignSearchValue,
  setCurrentTab,
  setHideSelectedLocationGroups,
  setHideSelectedLocations,
  setHideSelectedOrgGroups,
  setHideSelectedRoles,
  setHideSelectedStores,
  setHideSelectedUsers,
  setShowSelectedLocationGroups,
  setShowSelectedLocations,
  setShowSelectedOrgGroups,
  setShowSelectedRoles,
  setShowSelectedStores,
  setShowSelectedUsers,
  toggleLocationGroups,
  toggleOrgGroups,
  toggleRoles,
  toggleStores,
  toggleUsers,
} from 'store/Forms/actions'
import { fetchGroups, fetchRoles } from 'store/Group/actions'
import AxiosInstance from 'utils/AxiosInstance'
import AssignTabs from '../AssignTabs'
import { fetchUsersExtendedDetails } from 'store/Users/actions'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import CancelModalButton from 'components/Custom/CancelModalButton'
import CustomModalFooter from 'components/Custom/CustomModalFooter'
import { assignFormUsers } from 'store/Forms/actions'
import { fetchAssignedItems } from 'store/Forms/actions'

export default function AssignFormUsersModal({
  setShowAssignUsersModal,
  showAssignUsersModal,
  formId,
}) {
  const dispatch = useDispatch()
  const groups = useSelector((state) => state.groups)
  const [groupOrgs, setGroupOrgs] = useState([])
  const [soters, setStores] = useState([])

  const languageRedux = useSelector((state) => state.language?.language?.data)
  const language = languageRedux || {}

  const { usersExtendedDetails } = useSelector((store) => store.users)
  const forms = useSelector((store) => store.form)

  const items = {
    groupOrgs: groupOrgs,
    users: usersExtendedDetails,
    stores: soters,
    locationGroups: groups.locationGroups,
    roles: groups.roles,
  }

  const fetchOrgGroups = () => {
    AxiosInstance.get(`/groups/orgs`).then((data) => setGroupOrgs(data))
  }

  const fetchStores = async () => {
    await AxiosInstance.get(`/stores`).then((stores) => {
      const formatedStores = []

      if (Array.isArray(stores)) {
        stores.map((item) => {
          formatedStores.push({
            ...item,
            status: item.status === 'Active' ? true : false,
          })
          return item
        })
      }

      setStores(formatedStores)
    })
  }

  useEffect(() => {
    fetchOrgGroups()
    fetchStores()
    dispatch(fetchGroups())
    dispatch(fetchRoles())
    dispatch(fetchUsersExtendedDetails())
  }, [dispatch])

  // useEffect(() => {
  //     if (showSendWelcomeModal) {
  //         setSendingEmail(false)
  //     }
  // }, [showSendWelcomeModal])

  const toggleTabs = {
    toggleOrgGroups,
    toggleUsers,
    toggleLocationGroups,
    toggleStores,
    toggleRoles,
  }

  const hideSelectFunctions = {
    setHideSelectedOrgGroups,
    setHideSelectedLocationGroups,
    setHideSelectedLocations,
    setHideSelectedRoles,
    setHideSelectedStores,
    setHideSelectedUsers,
  }

  const showSelectFunctions = {
    setShowSelectedOrgGroups,
    setShowSelectedUsers,
    setShowSelectedStores,
    setShowSelectedRoles,
    setShowSelectedLocations,
    setShowSelectedLocationGroups,
  }

  useEffect(() => {
    dispatch(fetchAssignedItems(formId))

    return () => {
      dispatch(resetSelectedItems())
      dispatch(
        setCurrentTab(
          null,
          'category',
          'selectedOrgGroups',
          'groupOrgs',
          'toggleOrgGroups',
          'showSelectedOrgGroups',
          'setShowSelectedOrgGroups',
          'setHideSelectedOrgGroups'
        )
      )
      dispatch(setAssignSearchValue(''))
    }
  }, [dispatch, formId])

  return (
    <Modal
      toggle={() => setShowAssignUsersModal(false)}
      isOpen={showAssignUsersModal}
      centered
      size='lg'
    >
      <CustomModalHeader
        title='Assign Form Users'
        toggle={() => setShowAssignUsersModal(false)}
      />
      <ModalBody>
        <div className='d-flex flex-column align-items-start'>
          <div className='nav-wrapper col-12'>
            <Nav
              className='nav-fill flex-column flex-sm-row col-12 p-2 rounded '
              id='tabs-text'
              style={{ backgroundColor: '#f6f9fc' }}
              pills
              role='tablist'
            >
              <NavItem className='nav-items'>
                <NavLink
                  aria-selected={forms.currentTab === 'category'}
                  className={`mb-sm-3 mb-md-0 py-1 text-dark bg-transparent font-weight-bold 
                                                            ${
                                                              forms.currentTab ===
                                                              'category'
                                                                ? 'active-item'
                                                                : 'nav-item'
                                                            }`}
                  onClick={(e) =>
                    dispatch(
                      setCurrentTab(
                        e,
                        'category',
                        'selectedOrgGroups',
                        'groupOrgs',
                        'toggleOrgGroups',
                        'showSelectedOrgGroups',
                        'setShowSelectedOrgGroups',
                        'setHideSelectedOrgGroups'
                      )
                    )
                  }
                  href='#pablo'
                  role='tab'
                  size='sm'
                >
                  {language.general ? language.general.category : 'Category'}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  aria-selected={forms.currentTab === 'user'}
                  className={`mb-sm-3 mb-md-0 py-1 text-dark bg-transparent font-weight-bold 
                                                  ${
                                                    forms.currentTab === 'user'
                                                      ? 'active-item'
                                                      : 'nav-item'
                                                  }`}
                  onClick={(e) =>
                    dispatch(
                      setCurrentTab(
                        e,
                        'user',
                        'selectedUsers',
                        'users',
                        'toggleUsers',
                        'showSelectedUsers',
                        'setShowSelectedUsers',
                        'setHideSelectedUsers'
                      )
                    )
                  }
                  href='#pablo'
                  role='tab'
                  color='none'
                >
                  {language.general ? language.general.users : 'Users'}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  aria-selected={forms.currentTab === 'location-group'}
                  className={`mb-sm-3 mb-md-0 py-1 text-dark bg-transparent font-weight-bold 
                                                            ${
                                                              forms.currentTab ===
                                                              'location-group'
                                                                ? 'active-item'
                                                                : 'nav-item'
                                                            }`}
                  onClick={(e) =>
                    dispatch(
                      setCurrentTab(
                        e,
                        'location-group',
                        'selectedLocationGroups',
                        'locationGroups',
                        'toggleLocationGroups',
                        'showSelectedLocationGroups',
                        'setShowSelectedLocationGroups',
                        'setHideSelectedLocationGroups'
                      )
                    )
                  }
                  href='#pablo'
                  role='tab'
                >
                  {language.general
                    ? language.general.location_categories
                    : 'Location Groups'}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  aria-selected={forms.currentTab === 'stores'}
                  className={`mb-sm-3 mb-md-0 py-1 text-dark bg-transparent font-weight-bold 
                                                ${
                                                  forms.currentTab === 'stores'
                                                    ? 'active-item'
                                                    : 'nav-item'
                                                }`}
                  onClick={(e) =>
                    dispatch(
                      setCurrentTab(
                        e,
                        'stores',
                        'selectedStores',
                        'stores',
                        'toggleStores',
                        'showSelectedStores',
                        'setShowSelectedStores',
                        'setHideSelectedStores'
                      )
                    )
                  }
                  href='#pablo'
                  role='tab'
                >
                  {language.settings ? language.settings.location : 'Location'}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  aria-selected={forms.currentTab === 'job-title'}
                  className={`mb-sm-3 mb-md-0 py-1 text-dark bg-transparent font-weight-bold 
                                                            ${
                                                              forms.currentTab ===
                                                              'job-title'
                                                                ? 'active-item'
                                                                : 'nav-item'
                                                            }`}
                  onClick={(e) =>
                    dispatch(
                      setCurrentTab(
                        e,
                        'job-title',
                        'selectedRoles',
                        'roles',
                        'toggleRoles',
                        'showSelectedRoles',
                        'setShowSelectedRoles',
                        'setHideSelectedRoles'
                      )
                    )
                  }
                  href='#pablo'
                  role='tab'
                >
                  {language.settings
                    ? language.settings.assign_job_title
                    : 'Job Title'}
                </NavLink>
              </NavItem>
            </Nav>
          </div>
          <AssignTabs
            items={items[forms.currentItems]}
            toggleItem={toggleTabs[forms.currentToggleFunction]}
            selectedItems={forms.currentSelectedItems}
            mainProps={forms}
            assignSearchValue={forms.assignSearchValue}
            setHideSelectedItems={
              hideSelectFunctions[forms.currentHideSelectedItemsFunction]
            }
            setShowSelectedItems={
              showSelectFunctions[forms.currentShowSelectedItemsFunction]
            }
            showSelectedItems={forms[forms.currentShowSelectedItems]}
            // language={props.language}
            resetSelectedItems={resetSelectedItems}
            setCurrentTab={setCurrentTab}
            setAssignSearchValue={setAssignSearchValue}
            enableCategories={true}
            resetModal={forms.toggleModal}
          />
        </div>
      </ModalBody>
      <CustomModalFooter>
        <SubmitModalButton
          customFn={() => {
            dispatch(assignFormUsers(formId))
            setShowAssignUsersModal(false)
          }}
        ></SubmitModalButton>
        <CancelModalButton
          customFn={() => setShowAssignUsersModal(false)}
        ></CancelModalButton>
      </CustomModalFooter>
    </Modal>
  )
}
